import { render, staticRenderFns } from "./brigada-prevencion-registro.vue?vue&type=template&id=56a70f3e&scoped=true&"
import script from "./brigada-prevencion-registro.vue?vue&type=script&lang=js&"
export * from "./brigada-prevencion-registro.vue?vue&type=script&lang=js&"
import style0 from "./brigada-prevencion-registro.vue?vue&type=style&index=0&id=56a70f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a70f3e",
  null
  
)

export default component.exports